import { MasterpassAccountAccessRequest } from 'Models/MasterpassSdkModels';

/**
 * Masterpass hesap durumu sorgusu gövdesi.
 *
 * ⚠️ KRİTİK DEĞİŞİKLİK — eski `MFS.checkMasterPass` metodunun yeni SDK'da
 * DOĞRUDAN KARŞILIĞI YOKTUR. Hesap durumu artık ayrı bir sorgudan değil,
 * `accountService.accountAccess` cevabından türetilir:
 *
 *   - `result.accountStatus` doluysa doğrudan kullanılır,
 *   - değilse kart listesinin varlığından çıkarılır
 *     (bkz. `Stores/CreditCardTransactions/sagas.ts`).
 *
 * Bu türetmenin `MasterPassAccountStatusEnum` değerleriyle (`NO_ACCOUNT`,
 * `YES_ACCOUNT_NO_CARD`, `BLOCKED_ACCOUNT`, `NO_LINKED`) birebir örtüşüp
 * örtüşmediği Masterpass entegrasyon dokümanıyla DOĞRULANMALIDIR; hesap
 * bağlama (link) akışı bu değerlere göre dallanıyor.
 *
 * `accountKey` ve `userId` JWT'den geldiği için burada doldurulmaz.
 */
export const checkMasterPassAccountNormalize = (): Pick<MasterpassAccountAccessRequest, 'accountKeyType'> => ({
  accountKeyType: 'Msisdn',
});
